import * as React from "react";

import { Button } from "@blueprintjs/core";
import RemoderationActivityContainer from "~/containers/RemoderationActivityContainer";
import { IModerationOption } from "~/graphql/queries/optionRemoderation/optionsPendingRemoderation";
import styled from "~/styled";
import ProblemReporterButton from "../ProblemReporterButton";
import AlternativeImagesList from "./AlternativeImagesList";
import ImageCanvas from "./ImageCanvas";

interface IProps {
  canvasSrc: string | null;
  moderationOption: IModerationOption;
  onImageCanvasCommit: (image: File) => void;
  onAlternativeImageClick: (imageId: string, src: string) => void;
  onSubmit: () => void;
  onDelete: () => void;
}

const Layout = styled.div`
  background: #efeff3;

  height: 100vh;
  max-height: 100vh;
  width: 100vw;
  padding: 12px;

  display: grid;
  gap: 12px;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 2fr 1fr;
  grid-template-areas:
    "title actions"
    "image alternatives"
    "image activity";
`;

const Title = styled.h2`
  grid-area: title;
`;

const OptionName = styled.span`
  padding-left: 12px;
  opacity: 0.7;
`;

const ImageCanvasWrapper = styled.div`
  grid-area: image;
`;

const Alternatives = styled.div`
  grid-area: alternatives;
  overflow-y: auto;
`;

const Actions = styled.div`
  grid-area: actions;
  display: grid;
  grid-auto-flow: column;
  /* align-items: center; */
  gap: 12px;
`;

const Activity = styled.div`
  grid-area: activity;
`;

export default class RemoderationForm extends React.Component<IProps> {
  public render() {
    const {
      canvasSrc,
      moderationOption,
      onAlternativeImageClick,
      onImageCanvasCommit
    } = this.props;

    if (!moderationOption.image) {
      return null;
    }

    const images = moderationOption.option
      ? moderationOption.option.product.images
      : [];

    return (
      <Layout>
        <Title>
          Fix image for this option:{" "}
          {moderationOption.option.product.sourceName}
          <OptionName>{this.displayOptionName()}</OptionName>
        </Title>

        <ImageCanvasWrapper>
          <ImageCanvas src={canvasSrc} onCommit={onImageCanvasCommit} />
        </ImageCanvasWrapper>

        <Alternatives>
          <AlternativeImagesList
            images={images}
            onImageClick={onAlternativeImageClick}
          />
        </Alternatives>

        <Actions>
          <Button intent="danger" onClick={this.handleDelete}>
            Delete and next
          </Button>
          <Button intent="primary" onClick={this.handleSubmit}>
            Save and next
          </Button>
        </Actions>

        <Activity>
          <ProblemReporterButton
            meta={{ moderationOptionId: moderationOption.id }}
          />
          <RemoderationActivityContainer />
        </Activity>
      </Layout>
    );
  }

  private displayOptionName(): string {
    const {
      moderationOption: {
        option: { entities }
      }
    } = this.props;
    if (!(entities && entities.length)) {
      return "Default";
    }

    return entities
      .map(({ entity, value }) => `${entity}: ${value}`)
      .join(", ");
  }

  private handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    this.props.onSubmit();
  };

  private handleDelete = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    this.props.onDelete();
  };
}



// WEBPACK FOOTER //
// ./src/components/Remoderation/RemoderationForm.tsx